export const IconCvView20Bold: {
  name: 'icon_cv_view_20_bold-be2193562419'
} = {
  name: 'icon_cv_view_20_bold-be2193562419'
}
